import * as types from '@/store/mutation-types'
import { ModalSetup } from '@/skeletons/modal'

const state = {
  show: false,
  modalContent: {}
}

const getters = {
  isShow: state => state.show,
  content: state => state.modalContent
}

const actions = {
  launchModalWithData ({ commit }, data) {
    if (!data.orders.length || !Array.isArray(data.orders)) return false

    const setup = ModalSetup(data.type)
    if (!setup.validate()) return false

    const content = setup.contentSkeleton()
    const orderIds = data.orders.map(order => order.id)
    const orderCodes = data.orders.map(order => (order.supplierOrderCode || order.customerOrderCode || order.registration))
    const customerOrderCodes = data.orders.map(order => order.customerOrderCode)
    const storeCodes = data.orders.map(order => order.store.storeCode)

    content.body = {
      orderIds,
      orderCodes,
      storeCodes,
      customerOrderCodes,
      date: data.date
    }
    content.type = data.type

    commit(types.LAUNCH_MODAL, { ...content })
  },
  enable ({ commit }) {
    commit(types.START_MODAL)
  },
  disable ({ commit }) {
    commit(types.STOP_MODAL)
  },
  flush ({ commit }) {
    commit(types.CLEAN_MODAL)
  }
}

const mutations = {
  [types.LAUNCH_MODAL] (state, modalContent) {
    state.show = true
    state.modalContent = { ...modalContent }
  },
  [types.START_MODAL] (state) {
    state.show = true
  },
  [types.STOP_MODAL] (state) {
    state.show = false
  },
  [types.CLEAN_MODAL] (state) {
    state.modalContent = {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/modal.js